import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IconFire, IconGift } from '../../elements/Icon';

const WEEK_DAYS = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

function getLast35Days() {
    const result = [];

    const today = new Date();

    const currentDay = today.getUTCDay();
    const daysUntilSaturday = 6 - currentDay;

    const lastSaturday = new Date(today);
    lastSaturday.setUTCDate(today.getUTCDate() + daysUntilSaturday);

    for (let i = 34; i >= 0; i--) {
        const d = new Date(lastSaturday);
        d.setUTCDate(lastSaturday.getUTCDate() - i);

        const key = d.toISOString().split('T')[0];

        const isFuture = d > today;

        result.push({
            key,
            day: d.getUTCDate(),
            weekDay: WEEK_DAYS[d.getUTCDay()],
            isFuture,
        });
    }

    return result;
}

export const Strike = ({ onClose, countStrike, dailyScore }) => {
    const { t } = useTranslation();

    const storage = countStrike || localStorage.getItem('streak');

    const scores = dailyScore || [];

    const enabledDates = useMemo(() => {
        return new Set(
            scores
                .filter(item => item?.date)
                .map(item => item.date)
        );
    }, [scores]);

    const days = useMemo(() => {
        return getLast35Days().map((item) => ({
            ...item,
            enabled: !item.isFuture && enabledDates.has(item.key),
        }));
    }, [enabledDates]);

    return (
        <div
            onClick={onClose}
            className="w-full h-full absolute z-[60] bg-black/30 flex justify-center items-center px-4"
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className="
          bg-[#F8F4EA]
          border-[3px]
          border-[#7743BA]
          rounded-[18px]
          w-full
          max-w-[760px]
          p-4
          md:p-6
        "
            >
                <div className="flex items-center justify-center gap-2 mb-5">
                    <h2 className="text-[#4B96C9] text-[24px] md:text-[34px] font-bold text-center">
                        {t("day_streak").replace("X", storage)}
                    </h2>

                    <IconFire className="w-[24px] h-[24px] md:w-[32px] md:h-[32px]" />
                </div>

                <div className="flex gap-4 flex-col md:flex-row">
                    <div className="flex-1 border-r-0 md:border-r-[2px] border-[#D5CCA8] md:pr-4">
                        <div className="grid grid-cols-7 gap-1 mb-2">
                            {WEEK_DAYS.map((day) => (
                                <div
                                    key={day}
                                    className="text-center text-[10px] md:text-[12px] text-[#9F96A9] font-medium"
                                >
                                    {day}
                                </div>
                            ))}
                        </div>

                        <div className="grid grid-cols-7 gap-1 md:gap-2">
                            {days.map((item) => (
                                <div
                                    key={item.key}
                                    className={`
                    h-[28px]
                    md:h-[36px]
                    rounded-[6px]
                    flex
                    items-center
                    justify-center
                    text-[12px]
                    md:text-[15px]
                    font-bold
                    ${item.isFuture
                                            ? 'bg-transparent text-[#5B5368]'
                                            : item.enabled
                                                ? 'bg-[#6E3CB8] text-white'
                                                : 'bg-[#D9D0E5] text-white'}
                  `}
                                >
                                    {item.day}
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="w-full md:w-[240px] grid grid-cols-2 gap-3">
                        <div className=" border border-[#CFC7D9] rounded-[10px] p-3 flex flex-col items-center justify-center text-center min-h-[96px]">
                            <p className="text-[#4B96C9] text-[13px] font-bold mb-2">
                                2-3 days
                            </p>

                            <div className="flex items-center gap-1 text-[#4B96C9] font-bold text-[16px]">
                                +1
                                <IconGift className="w-[22px] h-[22px]" />
                            </div>
                        </div>

                        <div className=" border border-[#CFC7D9] rounded-[10px] p-3 flex flex-col items-center justify-center text-center min-h-[96px]">
                            <p className="text-[#4B96C9] text-[13px] font-bold mb-2">
                                4-6 days
                            </p>

                            <div className="flex items-center gap-1 text-[#4B96C9] font-bold text-[16px]">
                                +3
                                <IconGift className="w-[22px] h-[22px]" />
                            </div>
                        </div>

                        <div className=" border border-[#CFC7D9] rounded-[10px] p-3 flex flex-col items-center justify-center text-center min-h-[96px]">
                            <p className="text-[#4B96C9] text-[13px] font-bold mb-2">
                                7-9 days
                            </p>

                            <div className="flex items-center gap-1 text-[#4B96C9] font-bold text-[16px]">
                                +4
                                <IconGift className="w-[22px] h-[22px]" />
                            </div>
                        </div>

                        <div className=" border border-[#CFC7D9] rounded-[10px] p-3 flex flex-col items-center justify-center text-center min-h-[96px]">
                            <p className="text-[#4B96C9] text-[13px] font-bold mb-2">
                                +10 days
                            </p>

                            <div className="flex items-center gap-1 text-[#4B96C9] font-bold text-[16px]">
                                +5
                                <IconGift className="w-[22px] h-[22px]" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
